import { useMutation } from '@tanstack/react-query';

import { login } from '../api/auth.api';

import { useAuth } from './useAuth';

export function useLogin() {
  const { acceptSession } = useAuth();

  return useMutation({
    mutationFn: login,
    onSuccess: (session, variables) =>
      acceptSession({ ...session, remember: Boolean(variables?.remember) }),
  });
}
